import { post } from '@/utils/request'

/**
 * @method 获取专题列表
 */
export function getTopicList () {
  return post('/miniapps/User/login')
}
/**
 * @method 获取专题详情
 * @param {string} 专题ID
 */
export function getTopicDetail (id) {
  return post('/miniapps/User/login', { topicId: id })
}
/**
 * @获取首页的专题
 */
export function getHomeTopics(data){
  return post('/miniapps/activity/selectHomeCenterActivity',data)
}
/**
 * @首页的胖虎大牌
 */
export function getBigBrand(data){
  return post('/miniapps/activity/selectHomeBrandActivity',data)
}
/**
 * @首页的胖虎推荐
 */
export function getRecommend(data){
  return post('/miniapps/activity/selectHomeRecommendActivity',data)
}
/**
 * @优惠券
 */
export function getCoupon(data){
  return post('/miniapps/privilege/selectUserPrivilegeList',data)
}